export default "__VITE_ASSET__ed472709__"